{
  "Empty": "Gol"
}
